<template>
    <b-modal
        size="lg"
        title="Confirm Upload"
        ref="ConfirmUpload"
        @hidden="closeModal"
        centered>
        <div id="delete-survey" class="modal-form text-center py-4">
            Do you want to proceed with the upload?
        </div>
        <div slot="modal-footer">
            <b-button
                variant="ghost"
                class="btn-cancel"
                style="margin-right: .25rem;"
                @click="closeModal">
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="proceedUpload">
                Upload
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";
import notification from "../../../services/notification";

export default {
    name: "TransactionUploadConfirmUpload",
    props: ["open"],
    computed: {
        ...mapState("reportsTransactionUpload", ["importfile"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("reportsTransactionUpload/setConfirmModal", false);
        },
        proceedUpload: async function() {
            this.$store.commit("reportsTransactionUpload/setConfirmModal", false);

            if (
                this.importfile.type === "text/tab-separated-values" ||
                this.importfile.name.split(".").pop() === "tsv"
            ) {
                let size = (this.importfile.size * 0.00000095367432).toFixed(4);

                if (size > 10) {
                    notification.warning(
                        "You're uploading a file that is too big. File size limit is 10mb."
                    );
                } else {
                    await this.$store.commit(
                        "reportsTransactionUpload/setImportTransactionUpload",
                        this.importfile
                    );
                    await this.$store.dispatch(
                        "reportsTransactionUpload/readImportTransactionUpload"
                    );
                }
            } else {
                this.$store.commit("reportsTransactionUpload/setConfirmModal", false);
                notification.warning('You have used an invalid format. Please check the file format and try again.<br/>Note: Only TSV file is acceptable in the system.');
            }
        }
    },
    watch: {
        open: function(value) {
            if(value === true) {
                this.$refs.ConfirmUpload.show();
            } else {
                this.$refs.ConfirmUpload.hide();
            }
        }
    }
}
</script>
